import { createAsyncThunk } from '@reduxjs/toolkit';
import { executionAPI } from './executionAPI';

export const fetchTargetExecution = createAsyncThunk(
  'execution/fetchTargetExecution',
  async (queryParams) => {
    if (queryParams && queryParams?.fromDate && queryParams?.toDate) {
      const response = await executionAPI.fetchTargetExecution(queryParams);
      return response;
    }
  }
);
